// backend/util/calculate.js と同期
"use strict";

class Calculate {
  constructor() { }

  /**
   * 合計データ 作成
   * @param {Object} taxSettings
   * @param {Object} menus
   */
  createTotalData (taxSettings, menus) {
    // 計算方法
    const wayOfTotal = taxSettings.wayOfTotal;
    if (wayOfTotal === 0) {
      // 総額計算
      return this.calcTaxByGross(taxSettings, menus);
    } else {
      // 積上げ計算
      return this.calcTaxByStacking(taxSettings, menus);
    }
  }

  /**
   * 合計データ作成 (総額計算)
   * @param {*} taxSettings
   * @param {*} menus
   */
  calcTaxByGross (taxSettings, menus) {
    // 税率(default)
    let rateTypeDefault = taxSettings.rateType;
    if (!rateTypeDefault) {
      rateTypeDefault = 0; // 未定義の場合、10% とする
    }
    // console.log("rateTypeDefault", rateTypeDefault);

    // メニュー金額合計 計算
    const prices = this.sumMenuPrices(menus);
    // console.log("prices", prices);
    const pricesTax10 = this.sumMenuPricesTax10(menus, rateTypeDefault);
    const pricesTax8 = this.sumMenuPricesTax8(menus, rateTypeDefault);

    // 消費税 計算
    const wayOfRound = taxSettings.wayOfRound;
    // console.log("wayOfRound", wayOfRound);
    const tax10 = this.calcTax10(wayOfRound, pricesTax10);
    const tax8 = this.calcTax8(wayOfRound, pricesTax8);
    const taxTotal = tax10 + tax8;
    // console.log("(tax10, tax8, taxTotal)", tax10, tax8, taxTotal);

    return {
      prices: prices, //合計(税込)
      pricesTax10: pricesTax10, //10%対象(税込)
      pricesTax8: pricesTax8, //8%対象(税込)
      taxTotal: taxTotal, //消費税合計
    };
  }

  /* eslint-disable */
  calcTaxByStacking (taxSettings, menus) {
    //TODO 積上げ計算
    throw new Error("not implemented(積上計算)");
  }
  /* eslint-enable */

  calcTax10 (wayOfRound, prices) {
    const tax10 = function () {
      return (prices * 10) / 110;
    };
    return this.calcTaxCommon(wayOfRound, tax10);
  }

  calcTax8 (wayOfRound, prices) {
    const tax8 = function () {
      return (prices * 8) / 108;
    };
    return this.calcTaxCommon(wayOfRound, tax8);
  }

  calcTaxCommon (wayOfRound, calcTax) {
    // wayOfRound
    // 0:切捨て 1:切上げ 2:四捨五入
    if (wayOfRound === 0) {
      return Math.floor(calcTax());
    } else if (wayOfRound === 1) {
      return Math.ceil(calcTax());
    } else if (wayOfRound === 2) {
      return Math.round(calcTax());
    }
    throw new Error("not implemented: wayOfRound=", wayOfRound);
  }

  sumMenuPrices (menus) {
    // 全メニュー 合計金額(税込)
    return menus.reduce((sum, menu) => {
      return sum + this.calcMenuPrice(menu);
    }, 0);
  }

  sumMenuPricesTax10 (menus, rateTypeDefault) {
    // 10%対象 合計金額(税込)
    return menus
      .filter((menu) => this.isTargetTax10(menu, rateTypeDefault))
      .reduce((sum, menu) => {
        return sum + this.calcMenuPrice(menu);
      }, 0);
  }

  sumMenuPricesTax8 (menus, rateTypeDefault) {
    // 8%対象 合計金額(税込)
    return menus
      .filter((menu) => this.isTargetTax8(menu, rateTypeDefault))
      .reduce((sum, menu) => {
        return sum + this.calcMenuPrice(menu);
      }, 0);
  }

  calcMenuPrice (menu) {
    // メニュー+トッピング(税込)
    const toppings = menu.toppings;
    const menuPrice = menu.amountBaseEx + this.sumToppingsPrices(toppings);
    return menuPrice * menu.count; //数量
  }

  isTargetTax8 (menu, rateTypeDefault) {
    // 税率(8%)
    // メニューに個別定義がない場合 -> default を利用
    const consumptionTax = menu.consumptionTax;
    if (!consumptionTax || !Number.isInteger(consumptionTax.rateType)) {
      return rateTypeDefault === 0;
    }
    return consumptionTax.rateType === 0;
  }

  isTargetTax10 (menu, rateTypeDefault) {
    // 税率(10%)
    // メニューに個別定義がない場合 -> default を利用
    const consumptionTax = menu.consumptionTax;
    if (!consumptionTax || !Number.isInteger(consumptionTax.rateType)) {
      return rateTypeDefault === 1;
    }
    return consumptionTax.rateType === 1;
  }

  sumToppingsPrices (toppings) {
    // toppings
    //   name: "サイズ",
    //   selected: 1,
    //   type: "radio",
    //   values: [
    //     {id: "0", name: "タピオカ150%", amount: 100 },
    //     {id: "1", name: "タピオカ300%", amount: 200 },
    //     ...
    //   ]
    if (!toppings) {
      return 0;
    }

    const toppingPrices = toppings.reduce((sum, topping) => {
      // values 内の amount 合計 (radio だと1件のみになる)
      const toppingPrice = topping.values
        .filter((value) => value.id == topping.selected)
        .reduce((sum, value) => sum + value.amount, 0);
      return sum + toppingPrice;
    }, 0);
    return toppingPrices;
  }
}

export const calculate = new Calculate();
